<template>
  <div id="home">
    <!-- <a href="https://xyt.xcc.cn/getpcInfo?sn=1742021509418795008&language=CN&certType=8&url=*.czdh.cn"
      target="_blank"
      style="position: fixed; display: inline-block; height: 38px; z-index: 99999; top: 50%; right: 0; transform: translateY(-50%)">
      <div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"></div>
      <embed src="https://program.xinchacha.com/web/1742021509418795008=*.xiaoguoai.cn.svg" width="103" height="38"
        type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
    </a> -->
    <!-- 头部 -->
    <div class="header" id="a1"></div>
    <div class="line2" id="a2">
      <div class="line2-ctx">
        <div class="img1">
          <div class="img1_1">
            <h1>引领自适应教育新航标</h1>
          </div>
          <div class="img1_2">
            <span>成长导航是以学业规划的方式整体指导学科规划，通过AI智能工具的具体应用，结合成长档案的痕迹学习通过学校、家庭、规划老师一起推动的学业生涯规划体系。</span>
          </div>
          <div class="img1_3">
            <div class="line2_x1">
              <img :src="fontAssetsURL(`firstpage/icon_1.png`)" alt="">
              <p>AI智能学习系统</p>
            </div>
            <div class="line2_x2">
              <img :src="fontAssetsURL(`firstpage/icon_2.png`)" alt="">
              <p>学业生涯规划</p>
              <p>sy.czdh.cn</p>
            </div>
            <div class="line2_x3">
              <img :src="fontAssetsURL(`firstpage/icon_3.png`)" alt="">
              <p>成长导航商学院</p>
              <p>sy.czdh.cn</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="line3" id="a3">
      <div class="line3_but_1 line3_but_text">
        小学成绩规划
      </div>
      <div class="line3_but_2 line3_but_text">
        兴趣爱好
      </div>
      <div class="line3_but_3 line3_but_text">
        亲子教育
      </div>
      <div class="line3_but_4 line3_but_text">
        商学院
      </div>
      <div class="line3_but_5 line3_but_text">
        继续教育
      </div>
      <div class="line3_but_6 line3_but_text">
        研究生规划
      </div>
      <div class="line3_but_7 line3_but_text">
        小升初升学规划
      </div>
      <div class="line3_but_8 line3_but_text">
        大学学业生涯规划
        <p>(专升本)</p>
      </div>
      <div class="line3_but_9 line3_but_text">
        初中成绩规划
      </div>
      <div class="line3_but_10 line3_but_text">
        初中生大奖赛
      </div>
      <div class="line3_but_11 line3_but_text">
        中考集中训练
      </div>
      <div class="line3_but_12 line3_but_text">
        中考志愿填报
      </div>
      <div class="line3_but_13 line3_but_text">
        高一选科规划
      </div>
      <div class="line3_but_14 line3_but_text">
        高中成绩规划
      </div>
      <div class="line3_but_15 line3_but_text">
        高考志愿填报
      </div>

    </div>
    <div class="line4" id="a4">

    </div>
    <div class="line5" id="a5">
      <div class="line5_1">
        <h1>加盟只需三步</h1>
        <p>用科技让教育更高效，更公平</p>
        <span>www.czdh.cn</span>
        <div class="but_1">留言咨询</div>
        <div class="but_2">等待回访</div>
        <div class="but_3">签约合作</div>
      </div>
      <div class="line5_2">
        <textarea @keyup="problem = problem.replace(/^\s*|\s*$/g, '')" name="" id="line8-3-textarea" maxlength="200"
          v-model="problem" cols="30" rows="10" placeholder="请输入或选择咨询内容"></textarea>
        <div class="item-box">
          <div class="item-box-left">
            <div class="item-box-left-one">姓<span></span>名</div>
            <div class="item-box-left-two"></div>
          </div>
          <input class="input" @keyup="name = name.replace(/\s*/g, '')" type="text" placeholder="请输入您的姓名" maxlength="5"
            v-model="name" />
        </div>
        <br />
        <div class="item-box">
          <div class="item-box-left">
            <div class="item-box-left-one">电<span></span>话</div>
            <div class="item-box-left-two"></div>
          </div>
          <input class="input" @keyup="phone = phone.replace(/\D/g, '')" type="tel" placeholder="请输入您的手机号码" maxlength="11"
            v-model="phone" />
        </div>
        <br />
        <div class="item-box">
          <div class="item-box-left">
            <div class="item-box-left-one">验证码</div>
            <div class="item-box-left-two"></div>
          </div>
          <input class="input three" @keyup="code = code.replace(/\D/g, '')" type="text" maxlength="6" v-model="code"
            placeholder="请输入验证码" />
          <br />
        </div>
        <span class="code-btn" @click="handleIconClick"> {{ btnTxt }}</span>

        <button class="btn" @click="submit" :plain="true">立即咨询</button>
      </div>
      <div class="line5_3"  >
        <div @click="axiba($event)" class="line5_text1">您可以根据个人意向选择下列【快捷留言】</div>
        <div @click="axiba($event)" class="line5_text2">成长导航这个项目很好，请尽快与我详谈!</div>
        <div @click="axiba($event)" class="line5_text2">请问我所在的地区有成长导航的加盟校了吗 ?</div>
        <div @click="axiba($event)" class="line5_text2">对项目很感兴趣，请将成长导航项目资料发邮件给我!</div>
        <div @click="axiba($event)" class="line5_text2">做为成长导航的加盟校能得到哪些支持 ?</div>
        <div @click="axiba($event)" class="line5_text2">请问，现在加盟成长导航所需要的费用有哪些?</div>
        <div @click="axiba($event)" class="line5_text2">想了解成长导航的加盟流程，请与我联系!</div>
        <div @click="axiba($event)" class="line5_text2">我想加盟成长导航，请电话联系我!</div>
        <div @click="axiba($event)" class="line5_text2">现在加盟成长导航，有什么优惠政策吗?</div>
      </div>
      <div class="line5_4">
        <div>证书查询</div>
      </div>
    </div>
    <!-- <div class="line6" id="a6">
      <div class="line6-1">我们的优势</div>
      <div class="line6-2">
        覆盖教学全场景的教学辅助工具和资源平台，强大的数据挖掘和分析技术，有效提升教育信息化水平和教育决策能力，
        弥补教育信息化闭环中家长参与度不足的问题，促进全体学生实现符合个性化成长规律的智慧发展。
      </div>
      <div class="line6-3">
        <div class="line6-3-1">
          <div class="title">教师·以学定教</div>
          <div class="content">
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 3@2x.png`)" alt="" v-if="this.showme" />
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 3.png`)" alt="" v-if="!this.showme" />
            <div class="right-title">海量题库</div>
            <div class="right-content">
              独有全科知识点体系知识点与题目精准对应
            </div>
          </div>
          <div class="content">
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 2@2x.png`)" alt="" v-if="this.showme" />
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 2.png`)" alt="" v-if="!this.showme" />
            <div class="right-title">云端批改</div>
            <div class="right-content">
              覆盖全部题型 <br />
              真正实现减负增效
            </div>
          </div>
          <div class="content">
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 4@2x.png`)" alt="" v-if="this.showme" />
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 4.png`)" alt="" v-if="!this.showme" />
            <div class="right-title">学习报告</div>
            <div class="right-content">
              作业、小测试、考试行为结果数据全量收集
            </div>
          </div>
        </div>
        <div class="line6-3-2">
          <div class="title">学生·个性化学习</div>
          <div class="content">
            <img :src="fontAssetsURL(`firstpage/组 51@2x.png`)" alt="" v-if="this.showme" />
            <img :src="fontAssetsURL(`firstpage/组 51.png`)" alt="" v-if="!this.showme" />
            <div class="right-title">精准推送</div>
            <div class="right-content">
              作业数据结合推荐算法，定位薄弱点，自动推送复习题
            </div>
          </div>
          <div class="content">
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝@2x.png`)" alt="" v-if="this.showme" />
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝.png`)" alt="" v-if="!this.showme" />
            <div class="right-title">错题再练</div>
            <div class="right-content">
              自动添加错题至错题本，有效补全知识漏洞
            </div>
          </div>
        </div>
        <div class="line6-3-3">
          <div class="title">学生·个性化学习</div>
          <div class="content">
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 5@2x.png`)" alt="" v-if="this.showme" />
            <img :src="fontAssetsURL(`firstpage/组 51 拷贝 5.png`)" alt="" v-if="!this.showme" />
            <div class="right-title">进度追踪</div>
            <div class="right-content">
              随时查看孩子多维度学习报告，获得孩子的学习进度
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="line7" id="a7">
      <div class="line7-1">教学成果</div>
      <div class="line7-2">好效果不只是理论，我们已帮助数十万学生提成绩</div>
      <div class="line7-3">
        <div v-for="item in line7List" :key="item.id" class="line7-3-item">
          <img class="img" :src="item.src" alt="" />
          <div class="title">
            {{ item.title }}
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="line6 line8" id="a8">
      <div class="line6-1">机构风采</div>
      <div class="line6-2">因成绩而肯定，因价值而不凡</div>
      <div class="line6-3 campus-list">
        <div class="campus-item">
          <div class="img-box">
            <img :src="fontAssetsURL(`image/campus-1.png`)" alt="" />
          </div>
          <p>福建泉州校区</p>
        </div>
        <div class="campus-item">
          <div class="img-box">
            <img :src="fontAssetsURL(`image/campus-4.png`)" alt="" />
          </div>
          <p>深圳光明区弘乐校区</p>
        </div>
        <div class="campus-item">
          <div class="img-box">
            <img :src="fontAssetsURL(`image/campus-3.png`)" alt="" />
          </div>
          <p>恒大第1001校区</p>
        </div>
        <div class="campus-item">
          <div class="img-box">
            <img :src="fontAssetsURL(`image/campus-2.png`)" alt="" />
          </div>
          <p>深圳龙岗校区</p>
        </div>
      </div>
    </div> -->
    <!-- 锚点键 -->
    <div class="cur-href">
      <div class="item" v-for="(item, index) in alist" :key="index" :class="{ active: currentA === index }"
        @click="goHref(index)">
        <a :href="item.ctx"></a>
      </div>
    </div>

    <div class="backtop" v-show="this.backTop" @click="back">
      <img :src="fontAssetsURL(`firstpage/返回顶部.png`)" alt="" v-if="!this.showme" />
      <img :src="fontAssetsURL(`firstpage/返回顶部@2x.png`)" alt="" v-if="this.showme" />
    </div>
  </div>
</template>

<script>
import { throttle } from "../js/func.js";
import { fontAssetsURL } from "@/utils.js";
import { consultQuestion, getCode } from "../server/api";
export default {
  data() {
    return {
      btnTxt: "获取验证码",
      name: "",
      phone: "",
      code: "",
      problem: "",
      aa: 0,
      current3Item: 0, //line3当前选择项
      line3List: [], //line3列表
      currentWidth: 1920, //当前页面宽度
      line4bg: "", //line4背景图
      line4List: [], //line4列表
      current4Item: 0, //line4当前选择项
      showme: 0, //大小图片显示切换 0 | 1 == 小 | 大
      line7List: [], //line7列表
      backTop: false, //返回顶部
      currentA: 0, //a锚点当前
      alist: [
        {
          id: 0,
          ctx: "#a1",
        },
        {
          id: 1,
          ctx: "#a2",
        },
        {
          id: 2,
          ctx: "#a3",
        },
        {
          id: 3,
          ctx: "#a4",
        },
        {
          id: 4,
          ctx: "#a5",
        },
        {
          id: 5,
          ctx: "#a6",
        },

      ], ///a锚点列表
    };
  },
  created() {
    //获取line3,line4List
    this.getData();
  },
  mounted() {
    
    //滚动到2500距离出现返回顶部图标
    window.addEventListener("scroll", () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 2500) {
        this.backTop = true;
      } else {
        this.backTop = false;
      }
      // const arr = [10,300,900,1600,2250,3055]
      switch (true) {
        case 0 <= scrollTop && scrollTop < 10:
          this.currentA = 0;
          break;
        case 10 <= scrollTop && scrollTop < 300:
          this.currentA = 1;
          break;
        case 300 <= scrollTop && scrollTop < 900:
          this.currentA = 2;
          break;
        case 900 <= scrollTop && scrollTop < 1600:
          this.currentA = 3;
          break;
        case 1600 <= scrollTop && scrollTop < 2250:
          this.currentA = 4;
          break;
        case 2250 <= scrollTop && scrollTop < 3055:
          this.currentA = 5;
          break;
        case 3055 <= scrollTop && scrollTop < 3552:
          this.currentA = 6;
          break;
        case 3552 <= scrollTop:
          this.currentA = 7;
          break;
      }
    });
  },
  methods: {
   
    axiba(e) {
      console.log(e,'eeee');
      if (e.target.nodeName === "DIV") {
        this.problem = e.target.innerHTML;
      }
    },
    submit: throttle(function() {
      if (this.name.length === 0) {
        this.$message({
          message: "名字不能为空",
          type: "error",
          offset: 400,
        });
        return;
      }
      if (this.phone.length !== 11) {
        this.$message({
          message: "号码格式不正确",
          type: "error",
          offset: 400,
        });
        return;
      }
      if (this.code.length !== 6) {
        this.$message({
          message: "请输入正确的验证码",
          type: "error",
          offset: 400,
        });
        return;
      }
      if (!this.problem.length) {
        this.$message({
          message: "问题不能为空",
          type: "error",
          offset: 400,
        });
        return;
      }

      const submitData = {
        name: this.name,
        phone: this.phone,
        code: this.code,
        remark: this.problem,
        source: "web",
      };

      // this.$http
      //   .post(
      //     `https://test.xiaoguoai.cn:8083/admin/addIntentionalCustomer`,
      //     submitData
      //   )
      consultQuestion(submitData)
        .then((res) => {
          if (res && res.code === 200) {
            this.$message({
              message: "预约成功",
              type: "success",
              offset: 400,
            });
            this.name = "";
            this.phone = "";
            this.code = "";
            this.problem = "";
            clearInterval(this.time2);
            this.btnTxt = "获取验证码";
          } else {
            this.$message({
              message: res.message,
              type: "error",
              offset: 400,
            });
            clearInterval(this.time2);
            this.btnTxt = "获取验证码";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 500),
    handleIconClick() {
      let btn = this.checkForm();
      if (btn && this.btnTxt == "获取验证码") {
        this.timeComputer();
        let param = {
          openId: "gsApp",
          phone: this.phone,
        };
        getCode(param).then((res) => {
          if (res && res.code == 200) {
            this.$message({
              message: "发送成功",
              type: "success",
              offset: 100,
            });
          } else {
            this.$message({ message: res.message, type: "error", offset: 100 });
            clearInterval(this.time2);
            this.btnTxt = "获取验证码";
          }
        });
      }
    },
    timeComputer() {
      let time = 60;
      let that = this;
      this.btnTxt = time + "s";
      this.time2 = setInterval(function() {
        time--;
        if (time < 0) {
          clearInterval(that.time2);
          that.btnTxt = "获取验证码";
          return;
        }
        that.btnTxt = time + "s";
      }, 1000);
    },
    checkForm() {
      if (!this.isPoneAvailable(this.phone)) {
        return false;
      } else {
        return true;
      }
    },
    isPoneAvailable(num) {
      if (!String(num).trim()) {
        console.log("okkkkkkkkkkk");
        this.$message({ message: "请输入手机号", type: "error", offset: 100 });
        return false;
      }
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(String(num))) {
        this.$message({
          message: "请输入正确手机号",
          type: "error",
          offset: 100,
        });
        return false;
      } else {
        return true;
      }
    },
    //获取line3,line4List
    getData() {
      const currentWidth = document.documentElement.clientWidth;
      let a = currentWidth > 1920 ? "" : "";
      this.showme = currentWidth > 1920 ? 0 : 0;
      this.aa = a;
      this.line3List = [
        {
          id: 0,
          scr: fontAssetsURL(`firstpage/组 32${a}.png`),
          title: "传统线下培训",
          description:
            "无法全面了解每个学生的学习情况，无法解决针对性教学，招生成本高。",
        },
        {
          id: 1,
          scr: fontAssetsURL(`firstpage/组 34${a}.png`),
          title: "传统线上培训",
          description:
            "解决了区域问题，但是多为录制课程，课程质量层次不齐，无法保证学生吸收程度，无法落地达到提分的最终目的。",
        },
        {
          id: 2,
          scr: fontAssetsURL(`firstpage/组 32${a}(1).png`),
          title: "一对一教学",
          description:
            "可以有效监督教学，但对师资力量要求较高，极大增加投资者的成本。",
        },
        {
          id: 3,
          scr: fontAssetsURL(`firstpage/组 37${a}.png`),
          title: "人工智能教育",
          description:
            "AI+大数据赋能，利用大数据推送针对性学习内容，名师在线、分层教学、人机互动教学质量高。",
        },
      ];
      this.line4bg = fontAssetsURL(`firstpage/组 126${a}(2).png`);
      this.line4List = [
        {
          id: 0,
          title: "智能·学管双评估",
          content:
            "学管依托成长导航平台，运用大数据与人工智能算法，结合知识图谱精准分析学生实际状况，深入评估其学习水平。适时调整最佳学习方案，全面填补学生知识漏洞。",
        },
        {
          id: 1,
          title: "全面检测知识薄弱点情况",
          content:
            "课后综合测试，对比课前测评，综合检测学生知识薄弱点带你掌握变化情况，以便实时调整下一步学习内容。",
        },
        {
          id: 2,
          title: "智能检测学习水平",
          content:
            "人工智能技术全面扫描学科知识点，准确探测知识漏洞并产出可视化报告，360度解读学生知识点掌握情况。",
        },
        {
          id: 3,
          title: "个性化学习路径",
          content:
            "根据检测后的掌握情况，为学生智能匹配学习的内容，量身定制个性化的学习方案，每个学生都有一份属于自己的学习路径。",
        },
        {
          id: 4,
          title: "纳米级知识点练习",
          content:
            "把知识点拆成纳米级知识点，然后针对每个知识点进行专项练习，填补知识漏洞以构建学生完整的知识网。 ",
        },
      ];
      this.line7List = [
        {
          id: 0,
          src: fontAssetsURL(`firstpage/组 57${a}.png`),
          title: "14%+",
          content: "班级分数平均提升",
        },
        {
          id: 1,
          src: fontAssetsURL(`firstpage/组 58${a}.png`),
          title: "30%",
          content: "学生年级排名平均提升",
        },
        {
          id: 2,
          src: fontAssetsURL(`firstpage/组 59${a}.png`),
          title: "100%",
          content: "学生的进步率提升",
        },
        {
          id: 3,
          src: fontAssetsURL(`firstpage/组 60${a}.png`),
          title: "教学效率大幅提升",
          content: "每天节约老师2~3小时批改时间针对作业报告暴露问题专项讲解",
        },
        {
          id: 4,
          src: fontAssetsURL(`firstpage/组 126${a}(4).png`),
          title: "学习成绩显著提高",
          content: "使用成长导航平台后班级学生平均成绩明显提升",
        },
        {
          id: 5,
          src: fontAssetsURL(`firstpage/组 126${a}(5).png`),
          title: "认真程度与效果成正比",
          content: "使用学生名次提升与作业正确率呈显著相关性",
        },
      ];
    },
    //去锚点
    goHref(p) {
      this.currentA = p;
    },
    //鼠标移入切换line3投影
    mouseoverLine3(param) {
      this.current3Item = param;
    },
    //鼠标移入切换line4背景色
    mouseoverLine4(param) {
      this.current4Item = param;
    },
    //回到顶部
    back() {
      let h, backtopspeed, timer;
      timer = setInterval(() => {
        h = document.documentElement.scrollTop || document.body.scrollTop;
        backtopspeed = Math.floor(-h / 8);
        if (h > 0) {
          document.documentElement.scrollTop = document.body.scrollTop =
            h + backtopspeed;
        } else {
          clearInterval(timer);
        }
      }, 20);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../style/home.styl';
</style>
<style lang="scss" scoped>
.line2 {
  .line2-ctx {
    .img1 {
      font-family: Source Han Sans CN, Source Han Sans CN;
      color: #FFFFFF;

      .img1_1 {
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
        font-weight: bold;
        font-size: 42px;
        color: #FFFFFF;
        line-height: 50px;
        letter-spacing: 2px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .img1_2 {
        width: 700px;
        height: 83px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 300;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .img1_3 {
        position: relative;
        padding-right: 30px;
        padding-left: 30px;
        margin-top: 100px;
        width: 1180px;
        height: 160px;
        background: rgba(91, 157, 255, 0.2);
        border-radius: 8px 8px 8px 8px;

        // display: flex;
        // justify-content: space-between; 
        p {

          margin: 0px;
          text-align: center;
        }

        .line2_x1 {
          margin: auto;
          position: absolute;
          left: 100px;
          bottom: 45px;

        }

        .line2_x2 {
          margin: auto;
          position: absolute;
          left: 550px;
          bottom: 30px;

        }

        .line2_x3 {
          margin: auto;
          position: absolute;
          left: 1000px;
          bottom: 30px;
        }
      }
    }
  }
}

.line3 {
  position: relative;

  .line3_but_text {
    width: 108px;
    height: 24px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #2B4C77;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }

  .line3_but_1 {
    position: absolute;
    top: 170px;
    left: 385px;
  }

  .line3_but_2 {
    position: absolute;
    top: 170px;
    left: 560px;
  }

  .line3_but_3 {
    position: absolute;
    top: 170px;
    left: 730px;
  }

  .line3_but_4 {
    position: absolute;
    top: 170px;
    left: 1080px;
  }

  .line3_but_5 {
    position: absolute;
    top: 170px;
    left: 1250px;
  }

  .line3_but_6 {
    position: absolute;
    top: 170px;
    left: 1430px;
  }

  .line3_but_7 {
    width: 126px;
    position: absolute;
    top: 350px;
    left: 380px;
  }

  .line3_but_8 {
    width: 145px;
    position: absolute;
    top: 350px;
    left: 1405px;

    p {
      margin: 0;
    }
  }

  .line3_but_9 {
    width: 126px;
    position: absolute;
    top: 530px;
    left: 380px;
  }

  .line3_but_10 {
    width: 126px;
    position: absolute;
    top: 530px;
    left: 550px;
  }

  .line3_but_11 {
    width: 126px;
    position: absolute;
    top: 530px;
    left: 720px;
  }

  .line3_but_12 {
    width: 126px;
    position: absolute;
    top: 530px;
    left: 895px;
  }

  .line3_but_13 {
    width: 126px;
    position: absolute;
    top: 530px;
    left: 1075px;
  }

  .line3_but_14 {
    width: 126px;
    position: absolute;
    top: 530px;
    left: 1245px;
  }

  .line3_but_15 {
    width: 126px;
    position: absolute;
    top: 530px;
    left: 1425px;
  }
}

.line4 {
  background: url('../assets/firstpage/bg_line4.png') no-repeat;
}

.line5 {
  position: relative;
  color: #FFFFFF;

  .line5_1 {
    position: absolute;
    left: 400px;
    text-align: center;

    h1 {
      height: 30px;
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      font-weight: bold;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 30px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    p {
      width: 208px;
      height: 21px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #F1F2F4;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;

    }

    span {
      width: 100px;
      height: 21px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #FFE64B;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    div {
      width: 72px;
      height: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 36px;
      text-shadow: 0px 0px 20px rgba(25, 69, 197, 0.4);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .but_1 {
      position: absolute;
      left: 90px;
      top: 180px;
    }

    .but_2 {
      position: absolute;
      left: 90px;
      top: 270px;
    }

    .but_3 {
      position: absolute;
      left: 90px;
      top: 355px;
    }
  }

  .line5_2 {
    position: absolute;
    left: 720px;
    top: 40px;
  }

  .line5_3 {
    position: absolute;
    left: 1250px;
    top: 70px;

    .line5_text1 {
      width: 266px;
      height: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 14px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .line5_text2 {
      padding: 0px 5px;
      margin-top: 5px;
      height: 36px;
      background: #0076B8;
      border-radius: 4px 4px 4px 4px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 36px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .line5_text2:hover {
      color: #d7dee9
    }

  }

  .line5_4 {
    position: absolute;
    left: 1600px;
    top: 410px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

}
</style>
